module.exports = __webpack_public_path__ + "images/emoji/secret.c604fc18f7221e24c67b.png";